import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "HeaderChunksAndFooterLazy" */ './ShopDepartmentMenu'),
    { fallback: null }
);
